export default "__VITE_ASSET__ByNGU9sv__"